module.exports = __webpack_public_path__ + "static/TangleTower4-b1c90499e267e97380f6179e59da106f.webp";